import { render, staticRenderFns } from "./card_detil.vue?vue&type=template&id=2b136710&scoped=true"
import script from "./card_detil.vue?vue&type=script&lang=js"
export * from "./card_detil.vue?vue&type=script&lang=js"
import style0 from "./card_detil.vue?vue&type=style&index=0&id=2b136710&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b136710",
  null
  
)

export default component.exports